import { NON_EU_COUNTRY_VALUES } from '@/enums';

const NON_EU_COUNTRY_LABELS: Record<number, string> = {
  [NON_EU_COUNTRY_VALUES.ARGENTINA]: 'Argentina',
  [NON_EU_COUNTRY_VALUES.AUSTRALIA]: 'Australia',
  [NON_EU_COUNTRY_VALUES.BOLIVIA]: 'Bolivia',
  [NON_EU_COUNTRY_VALUES.BRAZIL]: 'Brazil',
  [NON_EU_COUNTRY_VALUES.CANADA]: 'Canada',
  [NON_EU_COUNTRY_VALUES.CHINA]: 'China',
  [NON_EU_COUNTRY_VALUES.COLOMBIA]: 'Colombia',
  [NON_EU_COUNTRY_VALUES.COSTA_RICA]: 'Costa Rica',
  [NON_EU_COUNTRY_VALUES.ECUADOR]: 'Ecuador',
  [NON_EU_COUNTRY_VALUES.GUATEMALA]: 'Guatemala',
  [NON_EU_COUNTRY_VALUES.HONDURAS]: 'Honduras',
  [NON_EU_COUNTRY_VALUES.JAPAN]: 'Japan',
  [NON_EU_COUNTRY_VALUES.KENYA]: 'Kenya',
  [NON_EU_COUNTRY_VALUES.MEXICO]: 'Mexico',
  [NON_EU_COUNTRY_VALUES.NEW_ZEALAND]: 'New Zealand',
  [NON_EU_COUNTRY_VALUES.PANAMA]: 'Panama',
  [NON_EU_COUNTRY_VALUES.PARAGUAY]: 'Paraguay',
  [NON_EU_COUNTRY_VALUES.PHILIPPINES]: 'Philippines',
  [NON_EU_COUNTRY_VALUES.UNITED_KINGDOM]: 'United Kingdom',
  [NON_EU_COUNTRY_VALUES.OTHER]: 'Other',
};

export const nonEuCountryFormatter = (params: { value: number | null }) =>
  (params.value != null && NON_EU_COUNTRY_LABELS[params.value]) || '';
